<template>
  <div id="app">
    <vue100vh :css="{height: '100rvh'}">
      <router-view/>
    </vue100vh>
  </div>
</template>

<script>
import vue100vh from 'vue-100vh'
export default {
  components: {
    vue100vh
  }
}
</script>